import { getFullName } from "@/services/generic.methods";

export const responseKeys = {
  leadAssigned: "LeadAssigned",
  leadExport: "LeadExport",
  smsReceived: "SMSReceived",
  leadReceived: "NewLeadReceived",
  optinLeadReceived: "SMSOptIn",
  leadAdded: "LeadAdded",
  bulkLeadAssigned: "BulkLeadAssigned",
  emailReceived: "EmailReceived",
  emailOpened: "EmailOpened",
  emailClicked: "EmailClicked",
  appointmentReminder: "AppointmentReminder",
  eventCreated: "EventCreated",
  eventConfirmation: "EventConfirmation",
  eventScheduled: "EventScheduled",
  eventUpdated: "EventUpdated",
  eventRescheduled: "EventRescheduled",
  eventReminder: "EventReminder",
  eventCancelled: "EventCancelled",
  eventCanceled: "EventCanceled",
  taskAssigned: "TaskAssigned",
  reminderTrigged: "ReminderTrigged",
  taskStatus: "TaskStatus",
  taskCompleted: "TaskCompleted",
  taskComment: "TaskComment",
  callReceived: "ApexVoiceCallLeadUpdated",
  reportExport: "ReportExport",
};

const {
  leadAssigned,
  leadExport,
  smsReceived,
  leadReceived,
  optinLeadReceived,
  leadAdded,
  bulkLeadAssigned,
  emailReceived,
  emailOpened,
  emailClicked,
  appointmentReminder,
  taskAssigned,
  reminderTrigged,
  taskStatus,
  taskComment,
  taskCompleted,
  callReceived,
  reportExport,
} = responseKeys;
// notifications types (eg: lead=> received, assigned..)
export const notificationTypes = {
  leads: {
    assinged: leadAssigned,
    export: leadExport,
    reportExport: reportExport,
    sms: smsReceived,
    received: leadReceived,
    optin: optinLeadReceived,
    added: leadAdded,
    bulkAssigned: bulkLeadAssigned,
    emailReceived: emailReceived,
    emailOpened: emailOpened,
    emailClicked: emailClicked,
    appointmentReminder: appointmentReminder,
    callReceived: callReceived,
    // lead: 0,
    // assinged: 1,
    // statusChanged: 2,
    // sms: 3,
    // leadFailed: 4,
    // leadProcessing: 5,
    // smsFailed: 6,
  },
  task: {
    reminderTrigged: reminderTrigged,
    taskAssigned: taskAssigned,
    taskStatus: taskStatus,
    taskComment: taskComment,
    taskCompleted: taskCompleted,
  },
};

// lead headings notification types
export const titleTypes = {
  leads: {
    [leadAssigned]: "Lead assigned",
    [leadExport]: "Lead export",
    [reportExport]: "Report export",
    [smsReceived]: "SMS received",
    [leadReceived]: "Lead received",
    [emailReceived]: "Email Received",
    [appointmentReminder]: "Upcoming Appointment",
  },
  // leads: [
  //   "Lead received",
  //   "Lead assigned",
  //   "Lead status changed",
  //   "New SMS",
  //   "Lead Failed",
  //   "Lead Processing",
  //   "SMS failed",
  // ],
};

// lead notification details text
export const textTypes = {
  leads: {
    [leadAdded]: (data, selfAssign) => {
      const sender = selfAssign
        ? "you"
        : `<b>${getFullName(data.leadImportedBy)}</b>`;
      return `<b>${data.count}</b> new ${
        +data.count > 1 ? "leads" : "lead"
      } have been added by ${sender}`;
    },
    [leadReceived]: () => "You have received a new lead",
    [leadAssigned]: (assignee, from, isCurrentUser, selfAssign) => {
      // console.log(isCurrentUser);
      return selfAssign
        ? "You have assigned the lead to yourself"
        : `Lead assigned to <b>${
            isCurrentUser ? "you" : assignee
          }</b> by <b>${from}</b>`;
    },
    2: (from) => ` ${from} has changed lead status`,
    [smsReceived]: () => "You have received a new SMS",
    4: (assignee) =>
      `The system is unable to add <b>'${assignee}'</b> at the moment. <b style='font-style: italic'>Retry</b>`,
    5: (assignee) =>
      `A new lead <b>'${assignee}'</b> is being processed. You will get a notification once completed`,
    6: () => `Sending SMS is failed`,
    [leadExport]: (fileName) =>
      fileName ? `${fileName} exported successfully` : "",
    [reportExport]: (fileName) =>
      fileName ? `${fileName} exported successfully` : "",
    [bulkLeadAssigned]: (data, selfAssign) =>
      selfAssign
        ? `You have assigned ${data.leadsCount} leads to yourself.`
        : `${data.leadAssignedBy.firstName} assigned ${data.leadsCount} lead(s) to you.`,
  },
};

// notification avatar type
export const avatarType = {
  avatar: "avatar",
  icon: "icon",
  initials: "initials",
};

const {
  eventCreated,
  eventConfirmation,
  eventScheduled,
  eventUpdated,
  eventRescheduled,
  eventReminder,
  eventCancelled,
  eventCanceled,
} = responseKeys;

export const appointmentNotificationTypes = {
  booked: [eventCreated, eventConfirmation, eventScheduled],
  cancelled: [eventCancelled, eventCanceled],
  rescheduled: [eventRescheduled, eventUpdated],
  reminder: [eventReminder, appointmentReminder],
};

export const allAppointmentTypes = [
  ...appointmentNotificationTypes.booked,
  ...appointmentNotificationTypes.cancelled,
  ...appointmentNotificationTypes.rescheduled,
  ...appointmentNotificationTypes.reminder,
];
